import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-grafico-header',
  templateUrl: './grafico-header.component.html',
  styleUrls: ['./grafico-header.component.scss']
})
export class GraficoHeaderComponent {

  @Input() titulo: string = '';
  @Input() pacienteNome: string = '';
  @Input() showHelp: boolean = true;

  @Output() help = new EventEmitter<void>();

}
